/**
 * Public configuration read at run time, so one image serves STG and PROD (서버이관 20 S13-6).
 *
 * The container writes `window.__ENV__` into /env-config.js at start-up from its VITE_* environment
 * (scripts/docker/web-runtime-env.sh) and index.html loads it before the app. Deployed bundles read
 * ONLY those values, so a setting left unset for an environment really is unset there — even if a
 * .env slipped into the build. Local dev and tests (not `vite build`) fall back to Vite's build-time
 * `import.meta.env` (.env files, vi.stubEnv). Everything here reaches the browser — no secrets.
 */

declare global {
  interface Window {
    __ENV__?: Readonly<Record<string, string | undefined>>
  }
}

/** A VITE_* value: the container's run-time value; in local dev/tests the build-time one. Empty = unset. */
export function readEnv(name: string): string | undefined {
  const runtime = typeof window === 'undefined' ? undefined : window.__ENV__?.[name]
  if (runtime) return runtime
  if (import.meta.env.PROD) return undefined
  const buildTime = (import.meta.env as Record<string, unknown>)[name]
  return typeof buildTime === 'string' && buildTime !== '' ? buildTime : undefined
}

/** API origin for the SDK client and data providers. */
export function getApiUrl(): string {
  return readEnv('VITE_API_URL') ?? 'http://localhost:3000'
}
